import React from "react";
import four_slider_01 from '../../assets/four_slider_01.avif';
import four_slider_02 from '../../assets/four_slider_02.avif';
import four_slider_03 from '../../assets/four_slider_03.avif';
import four_slider_04 from '../../assets/four_slider_04.avif';
import four_slider_05 from '../../assets/four_slider_05.avif';
import four_slider_06 from '../../assets/four_slider_06.avif';
import four_slider_07 from '../../assets/four_slider_07.avif';
import four_slider_08 from '../../assets/four_slider_08.avif';
import four_slider_09 from '../../assets/four_slider_09.avif';
import four_slider_10 from '../../assets/four_slider_10.avif';
import four_slider_11 from '../../assets/four_slider_11.avif';
import four_slider_12 from '../../assets/four_slider_12.avif';

const items = [
  { img: four_slider_01, title: 'Разработка бренд-стратегии', text: 'Исследование, позиционирование, архитектура бренда' },
  { img: four_slider_02, title: 'Таргетированная реклама', text: 'Настройка и ведение рекламы в соцсетях' },
  { img: four_slider_03, title: 'Контент-маркетинг', text: 'Создание контент-планов и производство материалов' },
  { img: four_slider_04, title: 'SEO-оптимизация', text: 'Комплексная оптимизация для поисковых систем' },
  { img: four_slider_05, title: 'Мобильный маркетинг', text: 'Продвижение в мобильных приложениях и сервисах' },
  { img: four_slider_06, title: 'Email-маркетинг', text: 'Настройка рассылок и автоматизация коммуникаций' },
  { img: four_slider_07, title: 'Продвижение в TikTok', text: 'Создание контента и ведение аккаунтов в TikTok' },
  { img: four_slider_08, title: 'Видеопродакшн', text: 'Съемка рекламных роликов и видео-контента' },
  { img: four_slider_09, title: 'Графический дизайн', text: 'Дизайн упаковки, полиграфия, наружная реклама' },
  { img: four_slider_10, title: 'PR и коммуникации', text: 'Работа со СМИ, кризисные коммуникации' },
  { img: four_slider_11, title: 'Аналитика данных', text: 'Сбор и анализ данных для принятия решений' },
  { img: four_slider_12, title: 'Комплексные кампании', text: 'Разработка и реализация 360° рекламных кампаний' },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const ProductShowcase = () => {
  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Каталог
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Наши продукты
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Получить консультацию <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Сетка: 6 колонок в ряд */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {items.map((item, index) => (
            <article
              key={index}
              className="group flex flex-col overflow-hidden rounded-xl border border-line-strong bg-surface transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]"
            >
              {/* Фотография (строгий квадрат) */}
              <div className="aspect-square w-full overflow-hidden bg-surface">
                <img 
                  src={item.img} 
                  alt={item.title} 
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105" 
                />
              </div>

              {/* Текстовая часть */}
              <div className="flex flex-1 flex-col border-t border-surface-2 bg-surface p-3.5">
                
                {/* Заголовок */}
                <h3 className="text-[12px] font-medium leading-snug text-content transition-colors group-hover:text-accent-hover">
                  {item.title}
                </h3>
                
                {/* Описание (сразу под заголовком, обрезается после 3 строк) */}
                <p className="mt-1 line-clamp-3 overflow-hidden text-[11px] font-light leading-tight text-muted">
                  {item.text}
                </p>

                {/* Ссылка "Подробнее" (выталкивается вниз с помощью mt-auto) */}
                <div className="mt-auto pt-3 flex cursor-pointer items-center justify-start gap-1 bg-surface text-[10px] font-medium text-content transition-colors hover:text-accent-hover group-hover:text-accent-hover">
                  Подробнее <Icon name="arrow" size={11} />
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Кнопка внизу */}
        <div className="mt-8 text-center">
          <button className="inline-flex items-center gap-2 rounded-lg border border-line-strong bg-surface px-6 py-2.5 text-xs font-medium text-content transition hover:border-accent-hover hover:text-accent-hover">
            Все продукты <Icon name="arrow" size={13} />
          </button>
        </div>
        
      </div>
    </section>
  );
};

export default ProductShowcase;